<script>
import ConsolidatorWalletFilter from '@modules/consolidator/components/consolidator-wallet-filter/consolidator-wallet-filter.vue'
import { walletFilters } from '@modules/consolidator/constants/filtros'
import { FIELD_KEY_TO_GETTER } from '@modules/consolidator/utils/normalize-wallet-filters/normalize-wallet-filters'
import { resolveWalletActiveCount } from '@modules/consolidator/utils/wallet-active-count/wallet-active-count'
import { normalizeFilterValue } from '@utils/filters'

export default {
  name: 'WalletFilters',
  components: { ConsolidatorWalletFilter },
  props: {
    fields: {
      type: Array,
      default: null,
    },
    enabledFieldKeys: {
      type: Array,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    menuWidth: {
      type: [String, Number],
      default: 420,
    },
  },
  data() {
    return {
      menuFilters: [{ key: 'wallet', type: 'slot', cols: 12 }],
      walletDraft: null,
    }
  },
  computed: {
    resolvedFields() {
      return Array.isArray(this.fields) ? this.fields : walletFilters
    },
    walletActiveCount() {
      return resolveWalletActiveCount({
        store: this.$store,
        fields: this.resolvedFields,
        enabledFieldKeys: this.enabledFieldKeys,
      })
    },
    walletAppliedSignature() {
      return this.buildWalletSignature((key) => this.readAppliedValue(key))
    },
    walletDraftSignature() {
      if (!this.walletDraft) return this.walletAppliedSignature
      return this.buildWalletSignature((key) =>
        key in this.walletDraft
          ? this.walletDraft[key]
          : this.readAppliedValue(key)
      )
    },
  },
  watch: {
    walletAppliedSignature: {
      handler() {
        this.$nextTick(() => this.syncMenuWalletState())
      },
      immediate: true,
    },
    walletDraftSignature() {
      this.$nextTick(() => this.syncMenuWalletState())
    },
  },
  methods: {
    onFilter(payload) {
      this.$emit('filter', payload)
    },
    onApply(flat, meta) {
      if (meta && meta.live === false && this.hasFilterRef()) {
        this.$refs.filter.blurOpenFields()
        this.$refs.filter.applyDraft()
      }
    },
    onClear() {
      if (this.hasFilterRef()) this.$refs.filter.clearToDefaults()
    },
    onMenuOpen() {
      if (this.hasFilterRef()) this.$refs.filter.resetDraft()
    },
    hasFilterRef() {
      return !!(this.$refs.filter && this.$refs.filter.resetDraft)
    },
    readAppliedValue(key) {
      const dateGetterByKey = {
        dataInicio: 'consolidator/walletFiltersDataInicio',
        dataFim: 'consolidator/walletFiltersDataFim',
      }
      const getter = dateGetterByKey[key] || FIELD_KEY_TO_GETTER[key]
      return getter ? this.$store.getters[getter] : null
    },
    buildWalletSignature(readValue) {
      const keys = [
        ...Object.keys(FIELD_KEY_TO_GETTER),
        'dataInicio',
        'dataFim',
      ]
      return JSON.stringify(
        keys.map((key) => normalizeFilterValue(readValue(key)))
      )
    },
    onWalletDraftChange(draft) {
      this.walletDraft = draft
    },
    syncMenuWalletState() {
      const menu = this.$refs.menu
      if (!menu) return
      if (menu.applied) menu.applied.wallet = this.walletAppliedSignature
      if (menu.draft) menu.draft.wallet = this.walletDraftSignature
    },
  },
}
</script>

<template>
  <BaseFilterMenu
    ref="menu"
    :filters="menuFilters"
    :menu-width="menuWidth"
    :active-count-override="walletActiveCount"
    menu-title="Filtros da carteira"
    @open="onMenuOpen"
    @apply="onApply"
    @clear="onClear"
  >

    <template v-slot:field-wallet>
      <ConsolidatorWalletFilter
        ref="filter"
        stacked
        defer-apply
        :fields="resolvedFields"
        :enabled-field-keys="enabledFieldKeys"
        :disabled="disabled"
        @filter="onFilter"
        @draft-change="onWalletDraftChange"
      />
    </template>
  </BaseFilterMenu>
</template>
